// extracted by mini-css-extract-plugin
export default {"container":"pO-z","topReviewHeading":"qO-z","criticalReview":"rO-z","favorableReview":"sO-z","vsSeparator":"tO-z"};